enum WebsocketActionType {
    INITIATE_SOCKET = "INITIATE_SOCKET",
    CLOSE_SOCKET = "CLOSE_SOCKET",
    SOCKET_OPENED = "SOCKET_OPENED",
    SUBSCRIBE_ROOM = "SUBSCRIBE_ROOM",
}

export default WebsocketActionType;